<template>
  <div>
    <div class="web">
      <div class="nav-wrap">
        <img class="logo-image cursor" :src="logoImage" @click="gogindex" />
        <div class="index-btns">
          <div class="index-btn cursor" @click="gogindex">首页</div>
          <div class="index-btn cursor">
            <button @click="showAboutUs" id="aboutUsButton">关于我们</button>
            <div
              class="about-menu"
              :style="{ display: isAboutVisible ? 'block' : 'none' }"
              @click.stop
              id="aboutMenu"
            >
              <div @click="aboutus">橘袋简介</div>
              <div @click="goMakeNutrition">定制营养</div>
              <div @click="goQuality">品质保障</div>
              <div @click="goBlog" style="">
                Blog
                <span style="opacity: 0">Blo</span>
              </div>
            </div>
          </div>
          <div class="index-btn cursor" @click="goProductSeries">产品系列</div>
          <div class="index-btn cursor" @click="fulfillment">行业解决方案</div>
        </div>
        <!-- <div class="question-btn cursor" @click="toMake($event,0)">开始定制</div> -->
        <div
          class="question-btn cursor"
          @mouseenter="toMake2($event, 0)"
          @mouseleave="hideCodePupop2"
        >
          开始定制
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="nav-warp">
        <div class="nav-warp-left">
          <div class="nav-warp-left-btn" @click="toMake($event, 0)">
            开始定制
          </div>
          <img class="nav-warp-left-logo" :src="logoImage" alt="" />
        </div>
        <div class="icon-wrap menu-list">
          <img
            class="nav-warp-right"
            :src="navIconImageH5"
            @click="showthisandmohu"
            id="h5MenuButton"
          />
          <div class="topbg" v-if="showmenu" @click="delmohu"></div>
          <div
            class="m-list animate__animated animate__fadeInRight"
            style="animate-delay: 0s; animate-duration: 0.2s"
            v-if="showmenu"
          >
            <div class="list-top-btn">
              <div class="list-close-btn" id="listclose" @click="mohu">
                <img src="../../public/imgs/listclose.png" alt="" />
              </div>
              <div
                class="list-close-btn"
                id="listmore"
                style="display: none"
                @click="mohu"
              >
                <img
                  class="back-tab-list"
                  src="../../public/imgs/more.png"
                  alt=""
                />
              </div>
              <div class="pagename" id="pagename"></div>
            </div>

            <div class="" id="page1">
              <div class="m-tab" @click="gogindex"><div>首页</div></div>
              <div class="m-tab" @click="getpage3">
                <div>关于我们</div>
                <img src="../../public/imgs/more.png" alt="" />
              </div>
              <div class="m-tab" @click="goProductSeries">
                <div>产品系列</div>
              </div>
              <div class="m-tab" @click="fulfillment">
                <div>行业解决方案</div>
              </div>
            </div>
            <div class="" id="page2" style="display: none"></div>
            <div class="" id="page3" style="display: none">
              <div class="m-tab" @click="aboutus">橘袋简介</div>
              <div class="m-tab" @click="goMakeNutrition">定制营养</div>
              <div class="m-tab" @click="goQuality">品质保障</div>
              <div class="m-tab" @click="goBlog">Blog</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 定制弹窗 -->
    <CodePupop
      ref="myPupop"
      :position="position"
      :left="left"
      :top="top"
    ></CodePupop>
    <!-- 定制弹窗 -->
    <CodePupop2
      ref="myPupop2"
      :position="position2"
      :left="left2"
      :top="top2"
    ></CodePupop2>
  </div>
</template>

<script>
import CodePupop2 from "./codePupop2.vue";
import CodePupop from "./codePupop.vue";
export default {
  name: "navs",
  components: {
    CodePupop,
    CodePupop2,
  },
  data: () => ({
    hasZuobiao: false,
    logoImage:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/logo.png",
    navIconImageH5:
      "https://nutripacks-static.oss-cn-shenzhen.aliyuncs.com/static/official_website/index/nav-icon-h5.png",
    isAboutVisible: false,
    isMenuVisible: false,

    showmenu: false,
    showmohu: false,
    pagenum: 1,

    position: "bottom",
    left: 0,
    top: 0,

    position2: "bottom",
    left2: 0,
    top2: 0,
  }),
  mounted() {
    // 在组件挂载后为 document 添加点击事件监听器
    document.addEventListener("click", this.hideAboutUs);
  },
  methods: {
    hideCodePupop() {
      this.$refs.myPupop.hidePupop();
    },
    hideCodePupop2() {
      this.hasZuobiao = false;
      this.$refs.myPupop2.hidePupop();
    },
    toMake2(event) {
      if (this.hasZuobiao) {
        return;
      }
      this.hasZuobiao = true;
      let clickX = event.clientX; // 相对于视口的X坐标
      let clickY = event.clientY; // 相对于视口的Y坐标

      console.log(clickX, clickY);

      this.left2 = clickX / 54 - 5;
      this.top2 = clickY / 54 - 0.5;
      this.$refs.myPupop2.showPupop();
    },
    toMake(event) {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let clickX = event.clientX; // 相对于视口的X坐标
      let clickY = event.clientY; // 相对于视口的Y坐标
      // 判断水平方向
      const horizontal = clickX < screenWidth / 2 ? "左" : "右";
      // 判断垂直方向
      const vertical = clickY < screenHeight / 2 ? "上" : "下";
      console.log(clickX, clickY);
      switch (horizontal + vertical) {
        case "左上":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 + 1 - 5;
          break;
        case "左下":
          clickX = clickX / 54 + 3;
          clickY = clickY / 54 - 8.5 + 5;
          break;
        case "右上":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 + 1.5 - 5;
          break;
        case "右下":
          clickX = clickX / 54 - 10;
          clickY = clickY / 54 - 9 + 5;
          break;
      }
      this.left = clickX;
      this.top = clickY;

      this.$refs.myPupop.showPupop();
    },
    showAboutUs() {
      this.isAboutVisible = true;
    },
    hideAboutUs(event) {
      const target = event.target;
      const button = document.getElementById("aboutUsButton");
      const aboutMenu = document.getElementById("aboutMenu");
      if (target !== button && target !== aboutMenu) {
        this.isAboutVisible = false;
      }
      console.log("hideAboutUs", this.isAboutVisible);
    },
    stopPropagation() {
      // 阻止元素 A 上的点击事件冒泡，避免触发 document 的点击事件
    },
    goMakeNutrition() {
      this.delmohu();
      this.$router.push("/make_nutrition");
      // window.location.href = "/make_nutrition";
    },
    goBlog() {
      this.delmohu();
      this.$router.push("/blog");
      // window.location.href = "/blog";
    },
    goQuality() {
      this.delmohu();
      this.$router.push("/quality");
      // window.location.href = "/quality";
    },
    goProductSeries() {
      this.delmohu();
      this.$router.push("/productSeries");
      // window.location.href = "/productSeries";
    },
    aboutus() {
      this.delmohu();
      // window.location.href = "/aboutUs";
      this.$router.push("/aboutUs");
    },
    fulfillment() {
      this.delmohu();
      this.$router.push("/fulfillment");
      // window.location.href = "/fulfillment";
    },
    gogindex() {
      this.delmohu();
      this.$router.push({
        path: "/",
      });
    },
    getpage1() {
      this.pagenum = 1;
      document.getElementById("pagename").innerHTML = "";
      document.getElementById("page1").style = "display:block";
      document.getElementById("page2").style = "display:none";
      document.getElementById("page3").style = "display:none";
      document.getElementById("listclose").style = "display:block";
      document.getElementById("listmore").style = "display:none";
    },
    getpage3() {
      document.getElementById("pagename").innerHTML = "关于我们";
      this.pagenum = 3;
      document.getElementById("page1").style = "display:none";
      document.getElementById("page2").style = "display:none";
      document.getElementById("page3").style = "display:block";
      document.getElementById("listclose").style = "display:none";
      document.getElementById("listmore").style = "display:block";
    },
    mohu() {
      if (this.pagenum == 1) {
        this.delmohu();
      } else {
        this.pagenum = 1;
        this.getpage1();
      }
    },
    delmohu() {
      this.pagenum = 1;
      this.showmenu = false;
      // this.getpage1()
      this.isAboutVisible = false;

      this.$emit("getback", { value: "", way: "0" });
    },
    showthisandmohu() {
      this.showmenu = !this.showmenu;
      this.$emit("getback", { value: "", way: "1" });
    },
  },
};
</script>

<style scoped lang="scss">
/* 统一鼠标样式 */
.cursor {
  cursor: pointer;
}
//mobile414
@media screen and (max-width: 767px) {
  .web {
    display: none;
  }
  .nav-warp {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 1.38rem;
    padding: 0 0.51rem 0 0.58rem;
    box-sizing: border-box;
    background: #ffffff;
    border-bottom: 0.01rem solid #e5e5e5;
  }

  .nav-warp-left {
    display: flex;
    align-items: center;
  }

  .nav-warp-left-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.13rem;
    height: 0.75rem;
    background: #c25e4d;
    border-radius: 0.72rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.29rem;
    color: #ffffff;
    line-height: 0.41rem;
  }

  .nav-warp-left-logo {
    width: 2.76rem;
    height: auto;
    margin: 0 0 0 0.92rem;
  }

  .icon-wrap {
    position: relative;
    padding-top: 0.1449rem;
    padding-left: 0.4831rem;
  }

  .nav-menu {
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    position: absolute;
    right: 0;
    top: 0.25rem;
    padding: 0.2rem 0.3rem;
    background: #fff;
    box-shadow: 0 0.15rem 0.3rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.19rem;
  }

  .nav-menu button {
    background: transparent;
    padding: 0.1rem;
  }

  .nav-menu div {
    padding: 0.1rem 0;
  }

  .nav-warp-right {
    width: 0.6rem;
    height: auto;
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
  .web {
    display: none;
  }
  .nav-warp {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 1.64rem;
    padding: 0 0.74rem 0 0.8rem;
    box-sizing: border-box;
    background: #ffffff;
    border-bottom: 0.01rem solid #e5e5e5;
  }

  .nav-warp-left {
    display: flex;
    align-items: center;
  }

  .nav-warp-left-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.37rem;
    height: 0.96rem;
    background: #c25e4d;
    border-radius: 0.56rem;

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.37rem;
    color: #ffffff;
    line-height: 0.52rem;
    text-align: right;
    font-style: normal;
  }

  .nav-warp-left-logo {
    width: 3.93rem;
    height: 0.74rem;
    margin: 0 0 0 1.96rem;
  }

  .icon-wrap {
    position: relative;
    padding-top: 0.1449rem;
    padding-left: 0.4831rem;
  }

  .nav-menu {
    display: flex;
    flex-direction: column;
    white-space: nowrap;
    position: absolute;
    right: 0;
    top: 0.25rem;
    padding: 0.2rem 0.3rem;
    background: #fff;
    box-shadow: 0 0.15rem 0.3rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.19rem;
  }

  .nav-menu button {
    background: transparent;
    padding: 0.1rem;
  }

  .nav-menu div {
    padding: 0.1rem 0;
  }

  .nav-warp-right {
    width: 0.6rem;
    height: auto;
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .mobile {
    display: none;
  }
  .web {
    margin: 1.85rem 0 0 0;
  }
  .nav-wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 4;
    display: grid;

    grid-template-columns: 4.32rem auto 2.96rem;
    grid-column-gap: 2.37rem;

    align-items: center;
    width: 100%;
    height: 1.85rem;
    background: #ffffff;
    padding: 0 1.89rem 0 1.91rem;
    box-sizing: border-box;
    border-bottom: 0.02rem solid #e5e5e5;
  }

  .logo-image {
    width: 4.32rem;
    height: auto;
  }

  .index-btns {
    display: flex;
    margin: 0 3.98rem 0 0;
  }

  .index-btn {
    position: relative;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #1a1a1a;
    line-height: 0.41rem;
    margin: 0 0 0 1.11rem;
    min-width: fit-content;
  }

  .index-btn button {
    background: transparent;
  }

  .about-menu {
    position: absolute;
    top: 0.56rem;
    left: 0;
    width: 2.76rem;
    box-shadow: 0 0.15rem 0.3rem 0 rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 0.19rem;
  }

  .about-menu div {
    text-align: center;
    padding: 0.15rem 0;
  }

  .about-menu div:first-child {
    border-radius: 0.19rem 0.19rem 0 0;
    padding: 0.3rem 0 0.15rem 0;
  }

  .about-menu div:last-child {
    border-radius: 0 0 0.19rem 0.19rem;
    padding: 0.15rem 0 0.3rem 0;
  }

  .about-menu div:hover {
    background: #c25e4d;
    color: #fff;
  }

  .question-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.96rem;
    height: 1.19rem;
    background: #c25e4d;
    border-radius: 0.15rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.37rem;
    color: #ffffff;
    line-height: 0.52rem;
  }

  .question-btn:hover {
    background-color: #d35e4f;
  }
}
// 1920
@media screen and (min-width: 1920px) {
  .mobile {
    display: none;
  }
  .web {
    margin: 1.85rem 0 0 0;
  }
  .nav-wrap {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 4;
    display: grid;
    grid-template-columns: 4.32rem auto 2.96rem;
    grid-column-gap: 2.37rem;
    align-items: center;
    width: 100%;
    height: 1.85rem;
    background: #ffffff;
    padding: 0 1.48rem 0 4.44rem;
    box-sizing: border-box;
    border-bottom: 0.02rem solid #e5e5e5;
  }

  .logo-image {
    width: 4.32rem;
    height: auto;
  }

  .index-btns {
    display: flex;
    margin: 0 3.98rem 0 0;
  }

  .index-btn {
    position: relative;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.3rem;
    color: #1a1a1a;
    line-height: 0.41rem;
    margin: 0 0 0 1.11rem;
    min-width: fit-content;
  }

  .index-btn button {
    background: transparent;
  }

  .about-menu {
    position: absolute;
    top: 0.56rem;
    left: 0;
    width: 2.76rem;
    box-shadow: 0 0.15rem 0.3rem 0 rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 0.19rem;
  }

  .about-menu div {
    text-align: center;
    padding: 0.15rem 0;
  }

  .about-menu div:first-child {
    border-radius: 0.19rem 0.19rem 0 0;
    padding: 0.3rem 0 0.15rem 0;
  }

  .about-menu div:last-child {
    border-radius: 0 0 0.19rem 0.19rem;
    padding: 0.15rem 0 0.3rem 0;
  }

  .about-menu div:hover {
    background: #c25e4d;
    color: #fff;
  }

  .question-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.96rem;
    height: 1.19rem;
    background: #c25e4d;
    border-radius: 0.15rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 0.37rem;
    color: #ffffff;
    line-height: 0.52rem;
  }

  .question-btn:hover {
    background-color: #d35e4f;
  }
}
</style>
